import { TableRowImage } from '@/components/TableRowImage';

interface ChannelLogoSlotProps {
  // `null` while the logo is pending: the slot stays empty.
  source: string | null;
  alt: string;
}

/**
 * The channel logo of an Emisora cell. Fixed width, empty while the logo is
 * pending, so the short name next to it never moves.
 */
export function ChannelLogoSlot({ source, alt }: ChannelLogoSlotProps) {
  return (
    <div className="w-8 shrink-0">
      <TableRowImage className="!max-w-8" source={source} alt={alt} />
    </div>
  );
}
